import {
  Configuration,
  type ConfigurationParameters,
  ProductsApi,
  StatementsApi,
  TransactionsApi,
  VariantsApi,
} from '@teemill/gfn-catalog';
import type { App } from 'vue';

export let statementsClient: StatementsApi;
export let transactionsClient: TransactionsApi;
export let productsClient: ProductsApi;
export let variantsClient: VariantsApi;

export let errorHandler: (e: any) => void;

export const gfn = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
      errorHandler: (e: any) => void;
    },
  ) {
    statementsClient = new StatementsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    transactionsClient = new TransactionsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    productsClient = new ProductsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    variantsClient = new VariantsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );

    errorHandler = options.errorHandler || ((e) => console.error(e));
  },
};
